/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Location_DetailsInputs */

const cs_property_location_details = /** @type {(inputs: Property_Location_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaily adresy`)
};

const en_property_location_details = /** @type {(inputs: Property_Location_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address details`)
};

/**
* | output |
* | --- |
* | "Address details" |
*
* @param {Property_Location_DetailsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_location_details = /** @type {((inputs?: Property_Location_DetailsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Location_DetailsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_location_details(inputs)
	return cs_property_location_details(inputs)
});